import { qfetch } from "@qgiv/core-js";

export const submitCreateOrder = (data = {}) =>
    qfetch.post(`/services/paypal/create_order.php`, data);

export const submitCreateBillingAgreement = (data = {}) =>
    qfetch.post(`/services/paypal/create_billing_agreement.php`, data);
